<app-painel-lateral [tituloPainel]="'Câmaras e Comissões Técnicas'" [descricaoPainel]="'Indicadores das comissões técnicas: composição, reuniões e tarefas.'" [iconePainel]="'pi pi-sitemap'" [filtrosTemplate]="filtros" [conteudoTemplate]="conteudo">
</app-painel-lateral>

<ng-template #filtros>
    <app-mapa-uf-card [uf]="ufSelecionada" (ufChange)="onUfSelecionadaChange($event)"></app-mapa-uf-card>
    <label class="mapa-filtro">
        <span class="mapa-filtro-label">UF do estado</span>
        <app-estado-select [uf]="ufSelecionada ?? 'BR'" [ufsPermitidas]="ufsPermitidas" (ufChange)="onUfSelecionadaChange($event)"></app-estado-select>
    </label>
    <label class="mapa-filtro">
        <span class="mapa-filtro-label">Ano (reuniões)</span>
        <input type="number" class="p-inputtext p-component" [(ngModel)]="anoSelecionado" min="1900" [max]="anoAtual + 1" />
    </label>
    <p-button label="Aplicar" icon="pi pi-search" (onClick)="aplicar()"></p-button>
</ng-template>

<ng-template #conteudo>
    @if (cardDetalhe) {
        <app-detalhamento-pendencias
            [indicador]="obterIndicadorDetalhe()"
            [linhas]="linhasDetalhe"
            [first]="firstDetalhe"
            [rows]="rowsDetalhe"
            [totalRecords]="totalDetalhe"
            [carregando]="carregandoDetalhe"
            [rotuloVoltar]="'Voltar aos indicadores'"
            [colunaIdentificador]="'ID'"
            [colunaNome]="'DESCRIÇÃO'"
            [colunaDetalhe]="'Detalhe'"
            [voltarNoCard]="true"
            [permitirVisualizacaoCard]="true"
            (voltar)="voltarParaCards()"
            (paginaAlterada)="onPageChangeDetalhe($event)"
        >
            <section detalhamento-acoes class="analitico-filtros-card">
                <label class="mapa-filtro">
                    <span class="mapa-filtro-label">Grupo</span>
                    <select class="p-inputtext p-component" [ngModel]="grupoCodigoDetalhe" (ngModelChange)="onGrupoDetalheChange($event)">
                        @for (opcao of obterOpcoesGrupo(cardDetalhe); track opcao.codigo) {
                            <option [value]="opcao.codigo">{{ obterDescricaoItem(opcao) }}</option>
                        }
                    </select>
                </label>
            </section>
        </app-detalhamento-pendencias>
    } @else {
        <section class="estatisticas-grid" aria-label="Indicadores das comissões técnicas">
            @for (card of cards; track card.id) {
                <div
                    class="card-entrada card-entrada-1"
                    [ngClass]="[card.classeGrupo, 'span-' + card.visualizacao]"
                    [class.estatistica-card-linha-inteira]="card.linhaInteira"
                    role="button"
                    tabindex="0"
                    [attr.aria-label]="'Ver detalhes de ' + card.titulo"
                    (click)="verDetalhe(card)"
                    (keydown.enter)="verDetalhe(card)"
                    (keydown.space)="$event.preventDefault(); verDetalhe(card)"
                >
                    <app-card-content [border]="false" [title]="card.titulo" [subtitle]="card.descricao" icon="pi pi-sitemap">
                        @if (possuiDetalhe(card)) {
                            <div card-header class="flex items-center gap-2" (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()">
                                <p-button icon="pi pi-table" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Visualizar dados" ariaLabel="Visualizar dados" (onClick)="$event.stopPropagation(); verDetalhe(card)"></p-button>
                            </div>
                        }

                        <div class="estatistica-total-bloco">
                            @if (obterTotalCard(card) !== null) {
                                <span class="estatistica-total-valor">{{ obterTotalCard(card) | number }}</span>
                                <span class="estatistica-total-label">{{ card.rotuloTotal }}</span>
                            } @else {
                                <p-skeleton width="92px" height="30px" />
                            }
                        </div>

                        <div class="estatistica-lista">
                            @if (card.carregando) {
                                @for (linha of [1, 2, 3, 4]; track linha) {
                                    <div class="estatistica-linha">
                                        <div class="estatistica-linha-texto">
                                            <p-skeleton width="130px" height="16px" />
                                            <p-skeleton width="80px" height="12px" />
                                        </div>
                                        <p-skeleton width="56px" height="20px" />
                                    </div>
                                }
                            } @else if (card.itens?.length) {
                                <div class="estatistica-grafico-container" [class.grafico-pizza]="card.visualizacao === 'rosca'">
                                    <p-chart [type]="obterTipoGrafico(card)" [data]="obterDadosGrafico(card)" [options]="obterOpcoesGrafico(card)"></p-chart>
                                </div>

                                @if (card.visualizacao !== 'linha') {
                                    @for (item of card.itens; track item.codigo ?? item.descricao ?? item.ordem) {
                                        <div class="estatistica-linha">
                                            <div class="estatistica-linha-texto">
                                                <span class="estatistica-item-descricao">{{ obterDescricaoItem(item) }}</span>
                                                <span class="estatistica-barra"><span [style.width]="obterLarguraBarra(card, item)"></span></span>
                                            </div>
                                            <span class="estatistica-item-total">{{ item.total ?? 0 | number }}</span>
                                        </div>
                                    }
                                }
                            } @else {
                                <div class="estatistica-sem-dados">Sem dados</div>
                            }
                        </div>
                    </app-card-content>
                </div>
            }
        </section>
    }
</ng-template>
